
import { faChevronRight } from '@fortawesome/pro-regular-svg-icons'

export default {
  name: 'ListLink',

  props: {
    hasArrow: {
      type: Boolean,
      default: true
    }
  },

  data() {
    return {
      faChevronRight
    }
  }
}
